import { BiDashboardSummary } from '@euler/model/bi/dashboard';

/** The caller's default first, then the latest edit first. */
export function biByDefaultThenRecent(
  a: BiDashboardSummary,
  b: BiDashboardSummary,
): number {
  if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1;
  return b.updatedAt.localeCompare(a.updatedAt);
}
